import { createContext, useContext, useState } from "react";
import BootstrapDropdown from "../../../components/BootstrapDropdown";
import {
  Textareawithsteroids,
  Textareawithsteroids2,
} from "../ESG/EnvironmentReport";
import { HeaderShow } from "../ESG/ESGmain";
import { RelevantGoals } from "./SDGmain";
import plusicon from "../../../assets/shapes_svg/roledetail/plusicon.svg";
import { useEffect } from "react";
import {
  getHighlightList,
  updateHighlightList,
} from "../../../apis/AmbitionList";
import CloseIcon from "@mui/icons-material/Close";
import Close from "@mui/icons-material/Close";
import { getHighlight, updateHighlight } from "../../../apis/Ambition";

const Step6Item = ({ title, size }) => {
  const goalIndex = useContext(GoalIndexContext);
  useEffect(() => {}, [goalIndex]);
  return (
    <div className="d-flex mt-3">
      <div
        className="esg__companyinfo d-flex py-3 px-1 w-30"
        style={{ height: "fit-content" }}
      >
        <h6 className="text-center">{title}</h6>
      </div>
      <div className="d-flex flex-column w-100 ms-3 esg__companyinfo p-4">
        <Textareawithsteroids2
          maxLength={3000}
          keyHighlight={
            "step6_item_" +
            title.replaceAll(" ", "_").replace("/", "_") +
            "_" +
            goalIndex
          }
          size={size}
        />
      </div>
    </div>
  );
};

const Time = ({ year, landmark, index, handleResult, years, setYears }) => {
  const [unstableText, setUnstableText] = useState(landmark);
  const [text, setText] = useState("");
  const [unstableYear, setUnstableYear] = useState(year);
  const [yearText, setYearText] = useState("");

  useEffect(() => {
    const timer = setTimeout(() => {
      setText(unstableText);
    }, 1000);
    return () => clearTimeout(timer);
  }, [unstableText]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setYearText(unstableYear);
    }, 1000);
    return () => clearTimeout(timer);
  }, [unstableYear]);

  useEffect(() => {
    handleResult(text, index, "landmark");
  }, [text]);

  useEffect(() => {
    handleResult(yearText, index, "year");
  }, [yearText]);
  return (
    <div className="d-flex  mt-3 w-100">
      <div className="timeline__time p-4 d-flex align-items-center justify-content-center">
        <input
          type="text"
          value={year}
          placeholder={"year"}
          onChange={(e) => {
            handleResult(e.target.value, index, "year");
          }}
        />
      </div>
      <div className="d-flex flex-column w-100 ms-3 esg__companyinfo p-4">
        <textarea
          style={{ minHeight: "150px" }}
          type="text"
          placeholder={""}
          value={unstableText}
          onChange={(e) => {
            setUnstableText(e.target.value);
          }}
        ></textarea>
      </div>
      {index == 0 && years.length === 1 ? (
        <></>
      ) : (
        <div
          className="mt-2"
          style={{ cursor: "pointer" }}
          onClick={() =>
            setYears((years) => years.filter((year, i) => i === index))
          }
        >
          <CloseIcon />
        </div>
      )}
    </div>
  );
};

const Timeline = ({ title }) => {
  const [years, setYears] = useState([]);

  const AddTimeline = ({ click }) => {
    return (
      <div
        className="add__timeline p-4 d-flex align-items-center justify-content-center align-self-start"
        onClick={click}
        style={{ cursor: "pointer" }}
      >
        <img className="w-40" src={plusicon} alt="" />
      </div>
    );
  };

  const handleResult = (value, index, property) => {
    setYears((prevs) => {
      return prevs.map((prev, i) => {
        if (i == index) {
          let obj = { ...prev };
          obj[property] = value;
          return obj;
        }
        return prev;
      });
    });
  };

  const handleGetYears = () => {
    getHighlightList({
      key: "sdg_timeline",
      setValue: setYears,
    });
  };

  const handleUpdateYears = () => {
    updateHighlightList({
      key: "sdg_timeline",
      value: years,
    });
  };

  useEffect(() => {
    handleGetYears();
  }, []);

  useEffect(() => {
    if (years.length > 0) handleUpdateYears();
  }, [years]);

  return (
    <div className="d-flex mt-3">
      <div
        className="esg__companyinfo d-flex py-3 px-1 w-30"
        style={{ height: "fit-content" }}
      >
        <h6 className="text-center">{title}</h6>
      </div>
      <div className="d-flex flex-column w-100 ms-3 esg__companyinfo p-4">
        {Array.isArray(years) &&
          years &&
          years?.map((year, i) => {
            return (
              <Time
                years={years}
                setYears={setYears}
                year={year.year}
                landmark={year.landmark}
                index={i}
                handleResult={handleResult}
              />
            );
          })}
        {years && years.length < 8 ? (
          <AddTimeline
            click={() => {
              setYears([
                ...years,
                {
                  year: "",
                  landmark: "",
                },
              ]);
            }}
          />
        ) : null}
      </div>
    </div>
  );
};

const TableEmptyRow = () => {
  return (
    <div className="writeinbox__row">
      <p></p>
      <p></p>
      <p></p>
      <p></p>
      <p></p>
      <p></p>
    </div>
  );
};

const RoadmapInput = ({ keyHighlight, value, setValue }) => {
  const [unstableText, setUnstableText] = useState("");
  useEffect(() => {
    const timer = setTimeout(() => {
      setValue(unstableText);
    }, 1000);
    return () => clearTimeout(timer);
  }, [unstableText]);

  const handleGetYears = () => {
    getHighlight({
      key: keyHighlight,
      setValue: setUnstableText,
    });
  };

  const handleUpdateYears = () => {
    updateHighlight({
      key: keyHighlight,
      value: value,
    });
  };

  useEffect(() => {
    handleGetYears();
  }, []);

  useEffect(() => {
    if (value != "") handleUpdateYears();
  }, [value]);

  return (
    <input
      type="text"
      style={{ color: "#193333" }}
      value={unstableText}
      onChange={(e) => setUnstableText(e.target.value)}
    />
  );
};

const RoadmapRow = ({ keys, values, setValues }) => {
  return (
    <>
      <h5>
        <RoadmapInput
          keyHighlight={keys[0]}
          value={values[0]}
          setValue={setValues[0]}
        />
      </h5>
      <h5>
        <RoadmapInput
          keyHighlight={keys[1]}
          value={values[1]}
          setValue={setValues[1]}
        />
      </h5>
      <h5>
        <RoadmapInput
          keyHighlight={keys[2]}
          value={values[2]}
          setValue={setValues[2]}
        />
      </h5>
      <h5>
        <RoadmapInput
          keyHighlight={keys[3]}
          value={values[3]}
          setValue={setValues[3]}
        />
      </h5>
      <h5>
        <RoadmapInput
          keyHighlight={keys[4]}
          value={values[4]}
          setValue={setValues[4]}
        />
      </h5>
    </>
  );
};

const Roadmap = ({ title }) => {
  const { relevantGoals } = useContext(RelevantGoals);
  const [goal1Indicator, setGoal1Indicator] = useState("");
  const [goal1KPI, setGoal1KPI] = useState("");
  const [goal1Starting, setGoal1Starting] = useState("");
  const [goal1Next, setGoal1Next] = useState("");
  const [goal1Decade, setGoal1Decade] = useState("");

  const [goal2Indicator, setGoal2Indicator] = useState("");
  const [goal2KPI, setGoal2KPI] = useState("");
  const [goal2Starting, setGoal2Starting] = useState("");
  const [goal2Next, setGoal2Next] = useState("");
  const [goal2Decade, setGoal2Decade] = useState("");

  const [goal3Indicator, setGoal3Indicator] = useState("");
  const [goal3KPI, setGoal3KPI] = useState("");
  const [goal3Starting, setGoal3Starting] = useState("");
  const [goal3Next, setGoal3Next] = useState("");
  const [goal3Decade, setGoal3Decade] = useState("");

  const [goal4Indicator, setGoal4Indicator] = useState("");
  const [goal4KPI, setGoal4KPI] = useState("");
  const [goal4Starting, setGoal4Starting] = useState("");
  const [goal4Next, setGoal4Next] = useState("");
  const [goal4Decade, setGoal4Decade] = useState("");

  const values = [
    [goal1Indicator, goal1KPI, goal1Starting, goal1Next, goal1Decade],
    [goal2Indicator, goal2KPI, goal2Starting, goal2Next, goal2Decade],
    [goal3Indicator, goal3KPI, goal3Starting, goal3Next, goal3Decade],
    [goal4Indicator, goal4KPI, goal4Starting, goal4Next, goal4Decade],
  ];
  const setValues = [
    [
      setGoal1Indicator,
      setGoal1KPI,
      setGoal1Starting,
      setGoal1Next,
      setGoal1Decade,
    ],
    [
      setGoal2Indicator,
      setGoal2KPI,
      setGoal2Starting,
      setGoal2Next,
      setGoal2Decade,
    ],
    [
      setGoal3Indicator,
      setGoal3KPI,
      setGoal3Starting,
      setGoal3Next,
      setGoal3Decade,
    ],
    [
      setGoal4Indicator,
      setGoal4KPI,
      setGoal4Starting,
      setGoal4Next,
      setGoal4Decade,
    ],
  ];

  const keys = [
    ["goal1Indicator", "goal1KPI", "goal1Starting", "goal1Next", "goal1Decade"],
    ["goal2Indicator", "goal2KPI", "goal2Starting", "goal2Next", "goal2Decade"],
    ["goal3Indicator", "goal3KPI", "goal3Starting", "goal3Next", "goal3Decade"],
    ["goal4Indicator", "goal4KPI", "goal4Starting", "goal4Next", "goal4Decade"],
  ];
  return (
    <>
      <div className="d-flex mt-3 ">
        <div
          className="esg__companyinfo d-flex py-3 px-1 w-30"
          style={{ height: "fit-content" }}
        >
          <h6 className="text-center">{title}</h6>
        </div>
      </div>
      <div className="d-flex flex-column w-100 ms-3 esg__companyinfo p-4">
        <div className="writeinbox__table  mb-3 w-100 mt-3">
          <div className="writeinbox__header text-center">
            <h5>
              <b>SDG</b>
            </h5>
            <h5>Indicator</h5>
            <h5>KPI</h5>
            <h5>Starting Point</h5>
            <h5>Next Year Target</h5>
            <h5>2030 Target</h5>
          </div>
          <div className="writeinbox__body">
            {Array.isArray(relevantGoals) &&
              relevantGoals.map((relevantGoal, i) => {
                return (
                  <>
                    <TableEmptyRow />
                    <div
                      className="writeinbox__row"
                      style={{ color: "#193666" }}
                    >
                      <h5>
                        {relevantGoal && relevantGoal.key
                          ? relevantGoal.key.replace("_", " ")
                          : ""}
                      </h5>

                      <RoadmapRow
                        keys={keys[i]}
                        values={values[i]}
                        setValues={setValues[i]}
                      />
                    </div>
                  </>
                );
              })}
          </div>
        </div>
      </div>
    </>
  );
};

const GoalIndexContext = createContext();
const Step6 = () => {
  const [showContent, setShowContent] = useState(false);
  const { relevantGoals } = useContext(RelevantGoals);
  const [goalIndex, setGoalIndex] = useState(0);

  return (
    <div className="d-flex flex-column align-items-center mt-2">
      <HeaderShow
        text={"Step 6 Roadmap Creation"}
        show={showContent}
        setShow={() => setShowContent(!showContent)}
      />
      {showContent ? (
        <div className="w-90 mt-3 ms-0 pt-3">
          <div className="esg__companyinfo d-flex w-100 justify-content-start mt-3 p-0">
            {relevantGoals && relevantGoals.length > 0 ? (
              <>
                <BootstrapDropdown
                  goals={relevantGoals}
                  name={(goal) => {
                    return goal?.key && goal.key.replace("_", " ");
                  }}
                  setImportantVar={setGoalIndex}
                  classStyle={"py-3 fs-5"}
                />
                <h5 className="ms-4 fw-normal">
                  {" "}
                  {relevantGoals[goalIndex]
                    ? relevantGoals[goalIndex].title
                    : null}
                </h5>
              </>
            ) : null}
          </div>
          <GoalIndexContext.Provider value={goalIndex}>
            <Step6Item title={"Geographical Coverage"} size={"small"} />
            <Step6Item title={"Implementation Period"} size={"small"} />
            <Step6Item title={"Key Stakeholders & Partnerships"} />
            <Step6Item title={"Corporate Definition & Rationale"} />
            <Step6Item title={"Baseline"} />
            <Step6Item title={"Data Sources & Collection Method"} />
            <Step6Item title={"Project Managers"} size={"small"} />
            <Step6Item
              title={"Global / third party Monitoring"}
              size={"small"}
            />
            <Step6Item title={"As is Status"} size={"small"} />
            <Step6Item title={"Will be Status"} size={"small"} />
          </GoalIndexContext.Provider>
          <Timeline title={"Timeline"} />
          <Roadmap title={"Roadmap"} />
        </div>
      ) : null}
    </div>
  );
};

export default Step6;
